import { connect } from 'react-redux'
import { 
  refreshApplication, refreshIncident,
  refreshTelecom, refreshApplicationCourt,
  refreshPlaintiff, refreshDefendant
 } from '../../store/modules/app';


//ui
import { TextField, Select, MenuItem, FormControl } from '@mui/material';
import Incident from '../components/application/Incident';
import _ from 'lodash';
import { useCallback, useEffect } from 'react';
import SelectCourt from '../components/application/SelectCourt';
import { useAppSelector } from '../../store';

const CourtList = [
  '대법원', '서울고등법원', '서울고등법원(춘천재판부)', '서울고등법원(인천재판부)', '대전고등법원', '대전고등법원(청주재판부)', '대구고등법원', '부산고등법원', '부산고등법원(창원재판부)', '부산고등법원(울산재판부)', '광주고등법원', '광주고등법원(제주재판부)', '광주고등법원(전주재판부)', '수원고등법원', '특허법원', '서울가정법원', '서울행정법원', '서울회생법원',
  '서울중앙지방법원', '서울동부지방법원', '서울남부지방법원', '서울북부지방법원', '서울서부지방법원',
  '의정부지방법원', '고양지원', '파주시법원', '포천시법원', '남양주시법원', '동두천시법원', '가평군법원', '연천군법원', '철원군법원',
  '인천지방법원', '인천지방법원 부천지원', '김포시법원', '강화군법원', '인천가정법원', '인천가정법원 부천지원',
  '수원지방법원', '성남지원', '여주지원', '평택지원', '안산지원', '안양지원', '용인시법원', '오산시법원', '광명시법원', '안성시법원', '광주시법원', '양평군법원', '이천시법원', '수원가정법원', '수원가정법원 성남지원', '수원가정법원 여주지원', '수원가정법원 평택지원', '수원가정법원 안산지원', '수원가정법원 안양지원',
  '춘천지방법원', '강릉지원', '원주지원', '속초지원', '영월지원', '홍천군법원', '양구군법원', '삼척시법원', '동해시법원', '정선군법원', '평창군법원', '태백시법원', '횡성군법원', '인제군법원', '화천군법원', '고성군법원', '양양군법원',
  '대전지방법원', '대전지방법원 홍성지원', '대전지방법원 공주지원', '대전지방법원 논산지원', '대전지방법원 서산지원', '대전지방법원 천안지원', '금산군법원', '세종특별자치시법원', '보령시법원', '서천군법원', '예산군법원', '아산시법원', '태안군법원', '당진시법원', '부여군법원', '청양군법원', '대전가정법원', '대전가정법원 홍성지원', '대전가정법원 공주지원', '대전가정법원 논산지원', '대전가정법원 서산지원', '대전가정법원 천안지원',
  '청주지방법원', '충주지원', '제천지원', '영동지원', '진천군법원', '보은군법원', '단양군법원', '음성군법원', '옥천군법원', '괴산군법원',
  '대구지방법원', '대구지방법원 서부지원', '대구지방법원 안동지원', '대구지방법원 경주지원', '대구지방법원 포항지원', '대구지방법원 김천지원', '대구지방법원 상주지원', '대구지방법원 의성지원', '대구지방법원 영덕지원', '경산시법원', '칠곡군법원', '청도군법원', '영천시법원', '성주군법원', '고령군법원', '영주시법원', '봉화군법원', '구미시법원', '문경시법원', '예천군법원', '청송군법원', '군위군법원', '울진군법원', '영양군법원', '대구가정법원', '대구가정법원 안동지원', '대구가정법원 경주지원', '대구가정법원 포항지원', '대구가정법원 김천지원', '대구가정법원 상주지원', '대구가정법원 의성지원', '대구가정법원 영덕지원',
  '부산지방법원', '부산지방법원 동부지원', '부산지방법원 서부지원', '부산가정법원',
  '울산지방법원', '양산시법원', '울산가정법원',
  '창원지방법원', '마산지원', '진주지원', '통영지원', '밀양지원', '거창지원', '창원남부시법원', '김해시법원', '함안군법원', '의령군법원', '사천시법원', '남해군법원', '하동군법원', '거제시법원', '고성군법원(경)', '창녕군법원', '합천군법원', '함양군법원', '산청군법원',
  '광주지방법원', '광주지방법원 목포지원', '광주지방법원 장흥지원', '광주지방법원 순천지원', '광주지방법원 해남지원', '담양군법원', '함평군법원', '강진군법원', '구례군법원', '영광군법원', '나주시법원', '장성군법원', '화순군법원', '곡성군법원', '광양시법원', '고흥군법원', '여수시법원', '보성군법원', '무안군법원', '영암군법원', '완도군법원', '진도군법원', '광주가정법원', '광주가정법원 목포지원', '광주가정법원 장흥지원', '광주가정법원 순천지원', '광주가정법원 해남지원',
  '전주지방법원', '군산지원', '정읍지원', '남원지원', '진안군법원', '김제시법원', '무주군법원', '임실군법원', '익산시법원', '부안군법원', '고창군법원', '장수군법원', '순창군법원',
  '제주지방법원', '서귀포시법원',
  '법원행정처'
]

//사실조회신청서
function FactFind(props) {

  const telecomList = useAppSelector((state) => state.app.application.telecomList);

  let plaintiff = useAppSelector((state) => state.app.plaintiff);
  let defendant = useAppSelector((state) => state.app.defendantList[0]);
  let incident = useAppSelector((state) => state.app.application.incident);
  let telecom = useAppSelector((state) => state.app.application.telecom);
  let court = useAppSelector((state) => state.app.application.court);

  const onIncidentData = useCallback(incident => {
    props.refreshIncident(incident);
  }, [])

  return (
    <div className="fact-find">
      <p className="head">사실조회 신청서</p>

      <div className="cont-bx">
        <p className="ttl">1) 사건 정보를 입력 해주세요.</p>
        <div className="answer-area item1">
          <div className="flex ai-start">
            <p className="item-ttl flex-row jc-sb"><span>사</span><span>건</span></p>
            <Incident
              isShowName={true}
              incident={incident}
              onData={onIncidentData}
            />
          </div>

          <div className="flex-row">
            <span className="item-ttl">원고 이름</span>
            <TextField
              // variant="outlined"
              value={plaintiff.name}
              //onChange={e => props.refreshApplication({...props.application, plaintiff: {...plaintiff, name: e.target.value}})}
              onChange={e => props.refreshPlaintiff({...plaintiff, name: e.target.value})}
            />
          </div>

          <div className="flex-row">
            <span className="item-ttl">피고 이름</span>
            <TextField
              // variant="outlined"
              value={defendant.name}
              onChange={e => props.refreshDefendant({...defendant, name: e.target.value})}
            />
          </div>
        </div>

        <hr />

        <p className="ttl">2) 피고의 휴대전화번호를 입력해 주세요.</p>
        <div className="answer-area item2">
          <TextField
            value={defendant.phone1}
            onChange={e => props.refreshDefendant({...defendant, phone1: e.target.value})}
            type="number"
          />
          <span>-</span>
          <TextField
            value={defendant.phone2}
            onChange={e => props.refreshDefendant({...defendant, phone2: e.target.value})}
            type="number"
          />
          <span>-</span>
          <TextField
            value={defendant.phone3}
            onChange={e => props.refreshDefendant({...defendant, phone3: e.target.value})}
            type="number"
          />
        </div>

        <hr />

        <p className="ttl">3) 사실조회 신청할 통신사를 선택해 주세요.</p>
        <div className="answer-area">
          <FormControl variant="outlined" className="select">
            <Select
              // id="demo-simple-select-outlined"
              value={telecom?.id || ''}
              onChange={e => props.refreshTelecom(telecomList[telecomList.map(t => t.id).indexOf(e.target.value)])}
              className="w240"
            >
              {telecomList.map((telecom, index) => (
                <MenuItem key={`telecom${index}`} value={telecom.id}>{telecom.company}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <hr />

        {/* <p className="ttl">4) 관할법원을 선택해 주세요.</p>
        <SelectCourt
          courtList={CourtList}
          court={court}
          onSelectCourt={court => props.refreshApplicationCourt(court)}
        /> */}
      </div>
    </div>
  )
}

let mapStateToProps = (state, /*ownProps*/) => {
  return {
      application: state.app.application,
  };
};

let mapDispatchToProps = (dispatch, /*ownProps*/) => {
  return {
      refreshApplication: (application) => dispatch(refreshApplication(application)),
      refreshIncident: (incident) => dispatch(refreshIncident(incident)),
      refreshPlaintiff: (plaintiff) => dispatch(refreshPlaintiff(plaintiff)),
      refreshDefendant: (data) => dispatch(refreshDefendant(data)),
      refreshTelecom: (data) => dispatch(refreshTelecom(data)),
      refreshApplicationCourt: (data) => dispatch(refreshApplicationCourt(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FactFind)
